module.exports = __webpack_public_path__ + "static/apple-PLsubway-e66a50a970512f071d78a61c265878dd.jpg";